<template lang="pug">
	.page
			.wrapper
				.contacts
					.contacts__title(data-aos="fade-up") Контакти
					.contacts__info(data-aos="fade-up" data-aos-delay="200") ТОВ "ФМС Україна"<br><br><br>БЦ «Іллінський»<br><br>вул. Іллінська 8, 10 блок, 6 поверх<br>04070
					.for-desktop
						.categories(data-aos="fade-up" data-aos-delay="400")
							.categories__row
								.categories__item(v-for="(card, index) in getRegions" :key="index")

									template(v-if="$route.params.slug === card.slug")
										.categories__btn(v-text="card.name" :class="{'categories__btn_active': $route.params.slug === card.slug}")

									template(v-else)
										router-link.categories__btn(v-text="card.name" :to="'/contacts/' + card.slug + '/'" :class="{'categories__btn_active': $route.params.slug === card.slug}")
									.categories__description( v-if="$route.params.slug == card.slug") {{ card.description }}
						.list(data-aos="fade-up" data-aos-delay="600")

							.card(v-for="(card, index) in getRegionBySlug($route.params.slug) ? getManagersByRegion(getRegionBySlug($route.params.slug).id) : []" :key="index")
								.card__image(:style="{backgroundImage: 'url(\"'+card.photo[400]+'\")'}")
								.card__content
									.card__name
										span(v-text="card.first_name")
										span(v-text="card.last_name")
									.card__job(v-text="card.job")
									.card__phone
										a(:href="'tel:' + card.phone" v-text="card.phone")
									.card__email
										a(:href="'mailto:' + card.email" v-text="card.email")
									.card__regions(v-if="card.regions_text" v-text="card.regions_text")
					.for-mobile
						.part(v-for="(card, index) in getRegions" :key="index")
							.categories__item
								button.categories__btn(@click="onChangeActive(card.id)" :class="{'categories__btn_active': activeRegion === card.id}") {{ card.name }}
									span
								.categories__description( v-if="$route.params.slug == card.id") {{ card.description }}
							slide-up-down(:active="activeRegion === card.id" :duration="300")
								.list
									.card(v-for="(item, i) in getManagersByRegion(card.id)" :key="i")
										.card__image(:style="{backgroundImage: 'url(\"'+item.photo[400]+'\")'}")
										.card__content
											.card__name
												span(v-text="item.first_name")
												span(v-text="item.last_name")
											.card__job(v-text="item.job")
											.card__phone
												a(:href="'tel:' + item.phone" v-text="item.phone")
											.card__email
												a(:href="'mailto:' + item.email" v-text="item.email")
											.card__regions(v-if="item.regions_text" v-text="item.regions_text")

</template>

<script>

	let collectionSlug = 'managers';

	import SlideUpDown from 'vue-slide-up-down';

	import AOS from 'aos';

	import {mapState, mapGetters} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {

			return {
				title: 'Контакти',
			}
		},
		data: function(){
			return {
				activeRegion: -1,
			}
		},
		methods: {
			check() {
				if (window.innerWidth > 1200) {
					// desktop
					if (!this.$route.params.slug && this.regions.length && this[collectionSlug].length) {
						this.$router.push({path: '/contacts/' + this.getRegions[0].slug + '/'})
					}

					if (this.$route.params.slug && this.regions.length && this[collectionSlug].length) {
						this.activeRegion = this.getRegions[0].slug;
					}
				} else {
					// mobile
					if (this.$route.params.slug) {
						this.$router.push({path: '/contacts/'});
					}
				}
			},
			onChangeActive(id) {
				this.activeRegion = this.activeRegion === id ? -1 : id;
				if (this.activeRegion != -1) {
					// this.$route.hash = '#' + this.activeRegion;
					// window.location.hash = this.activeRegion;
					// console.log(this.$route.hash);
				}
			}
		},
		created() {
			this.check();
		},
		components: {
			'slide-up-down': SlideUpDown,
		},
		computed: {
			...mapState([
				collectionSlug,
				'regions',
			]),
			...mapGetters([
				'getRegions',
				'getManagersByRegion',
				'getRegionBySlug'
			])
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		watch: {
			regions() {
				this.check();
			},
			managers() {
				this.check();
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.for-mobile {
		display: none;
	}

	.contacts {
		margin-bottom: 80px;

		&__title {
			@include kit('sectionTitle');
		}

		&__info {
			max-width: 400px;
			font: 700 14px/18px 'Helvetica', Arial, sans-serif;
			letter-spacing: .7px;
			margin-top: 15px;
			margin-bottom: 30px;
		}
	}

	.categories {
		display: table;
		width: calc(100% + 20px);
		table-layout: fixed;
		margin-left: -10px;
		margin-top: 54px;
		margin-bottom: 50px;
		position: relative;
		padding-bottom: 80px;

		&__description {
			position: absolute;
			left: 0;
			bottom: 0;
			font: 500 20px/23px 'Helvetica', 'Arial', sans-serif;
			color: #333333;
			padding-left: 10px;
			text-align: left;
			width: 100%;

		}

		&__row {
			display: table-row;
			
		}

		&__item {
			display: table-cell;
			width: 100%;
			text-align: center;
			padding: 0 10px;
		}

		&__btn {
			display: inline-block;
			vertical-align: top;
			height: 50px;
			background-color: #fff;
			width: 100%;
			font: 20px/50px Arial, sans-serif;
			letter-spacing: 1px;
			transition: background-color .5s ease, color .5s ease;
			outline: none;
			margin: 0;

			&_active {
				background-color: #EF3E33;
				color: #fff;
			}
		}
	}

	.list {
		margin: 0 -10px;
	}

	.card {
		display: inline-block;
		vertical-align: top;
		width: 413px;
		height: 197px;
		font-size: 0;
		margin: 0 10px 20px;
		background-color: #fff;
		overflow: hidden;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.05);

		&__image {
			display: inline-block;
			vertical-align: top;
			height: 100%;
			width: 197px;
			background-size: cover;
			background-position: center top;
			background-repeat: no-repeat;
		}

		&__content {
			display: inline-block;
			vertical-align: top;
			width: calc(100% - 197px);
			height: 100%;
			padding: 15px;
		}

		&__name {
			font: 700 21px/28px 'Helvetica', Arial, sans-serif;
			overflow: hidden;

			span {
				display: block;
			}
		}

		&__job {
			color: #EF3E33;
			font: 14px/16px Arial, sans-serif;
			overflow: hidden;
			margin-top: 10px;
		}

		&__phone {
			font: 500 12px/16px 'Helvetica', Arial, sans-serif;
			margin-top: 10px;
		}

		&__email {
			font: 500 12px/16px 'Helvetica', Arial, sans-serif;
			margin-top: 10px;
			white-space: nowrap;
		}

    &__regions {
      margin-top: 10px;
      font: 400 12px/16px 'Helvetica', Arial, sans-serif;
    }

		a {
			transition: opacity .5s ease;

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;
				}
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.for-desktop {
			display: none;
		}

		.for-mobile {
			display: block;
		}

		.list {
			margin-top: 0;
			margin-left: 0;
			width: 100%;
			padding-top: 20px;
			padding-bottom: 30px;
		}

		.contacts {
			&__info {
				margin-bottom: 40px;
				margin-top: 40px;
			}
		}

		.card {
			margin-bottom: 30px;
			height: 157px;
			width: 100%;
			margin-left: 0;
			margin-right: 0;

			&:last-child {
				margin-bottom: 0;
			}

			&__job {
				margin-top: 5px;
				font-size: 12px;
				line-height: 14px;
			}

			&__name {
				line-height: 25px;

				span {
					display: block;
					height: 20px;
				}
			}

			&__image {
				width: 138px;
			}

			&__phone {
				margin-top: 5px;
				font-size: 10px;
				line-height: 12px;
				white-space: nowrap;
			}

			&__email {
				font-size: 10px;
				line-height: 14px;
				margin-top: 5px;
			}

			&__regions {
				font-size: 10px;
				line-height: 12px;
				margin-top: 8px;
			}


			&__content {
				width: calc(100% - 138px);
				padding: 10px;
			}
		}

		.categories {
			display: block;

			&__item {
				width: 100%;
				margin: 0;
				padding: 0;
				display: block;
				// margin-bottom: 10px;
				margin-bottom: 0;
				padding-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}

			&__btn {
				margin: 0;
				width: 100%;
				position: relative;
				font-size: 16px;

				span {
					display: block;
					position: absolute;
					top: 0;
					right: 0;
					width: 50px;
					height: 100%;
					box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.2);

					&:before {
						content: "";
						display: block;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						background: url('../assets/img/dropdown_white.svg') no-repeat center center;
						transition: transform .5s ease, opacity .5s ease;
						opacity: 0;
						transform: rotate(-180deg);
					}

					&:after {
						content: "";
						display: block;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						background: url('../assets/img/dropdown.svg') no-repeat center center;
						transition: transform .5s ease, opacity .5s ease;
						opacity: 1;
					}
				}

				&_active {
					span {
						&:after {
							transform: rotate(180deg);
							opacity: 0;
						}

						&:before {
							transform: rotate(0);
							opacity: 1;
						}
					}
				}
			}

			&__description {
				position: static;
				text-align: left;
				font-size: 14px;
				line-height: 16px;
				padding-left: 0;
				margin-top: 15px;
			}
		}

		.contacts {
			margin-bottom: 100px;
		}

		.part {
			&:last-child {
				.list {
					padding-bottom: 0;
				}
			}
		}
	}

	@media screen and (max-width: 325px) {
		.card {
			&__image {
				width: 120px;
			}

			&__content {
				width: calc(100% - 120px);
			}
		}
	}

</style>
